export const DBA_COLLECTION_MAPPINGS_RESET_STATE = 'DBA_COLLECTION_MAPPINGS_RESET_STATE';
export const DBA_COLLECTION_MAPPINGS_CURRENT_ITEM = 'DBA_COLLECTION_MAPPINGS_CURRENT_ITEM';

export const DBA_COLLECTION_MAPPINGS_REQUEST_LOADING = 'DBA_COLLECTION_MAPPINGS_REQUEST_LOADING';
export const DBA_COLLECTION_MAPPINGS_REQUEST_SUCCESS = 'DBA_COLLECTION_MAPPINGS_REQUEST_SUCCESS';
export const DBA_COLLECTION_MAPPINGS_REQUEST_FAILED = 'DBA_COLLECTION_MAPPINGS_REQUEST_FAILED';

export const DBA_COLLECTION_MAPPINGS_CURRENT_ACTION = 'DBA_COLLECTION_MAPPINGS_CURRENT_ACTION';
export const DBA_COLLECTION_MAPPINGS_RESET_ACTION = 'DBA_COLLECTION_MAPPINGS_RESET_ACTION';